const LOAN_HISTORY = {
  section: {
    name: 'loan-history',
    caption: 'LOAN HISTORY'
  },
  sectionFields: [
    { label: '#', template: '{index}', fieldKey: 'index' },
    { label: 'DISBURSEMENT DATE', template: '{effectiveDate}', fieldKey: 'effectiveDate', format: 'date' },
    { label: 'MATURITY DATE', template: '{maturityDate}', fieldKey: 'maturityDate', format: 'date' },
    { label: 'APPLICATION #', template: '{applicationNo}', fieldKey: 'applicationNo' },
    { label: 'STATUS', template: '{paidStatus}', fieldKey: 'paidStatus' },
    { label: 'APPROVED AMOUNT', template: '{approvedAmount}', fieldKey: 'approvedAmount', format: 'currency' },
    { label: 'LOAN AMOUNT', template: '{loanAmount}', fieldKey: 'loanAmount', format: 'currency' },
    { label: 'TOTAL PAID', template: '{totalPaid}', fieldKey: 'totalPaid', format: 'currency' },
    { label: 'TOTAL LEFT', template: '{totalLeft}', fieldKey: 'totalLeft', format: 'currency' },
    { label: 'D/C RATIO', template: '{DCRatio}', fieldKey: 'DCRatio', format: 'percent' }
  ]
}
export default LOAN_HISTORY
